import React from 'react';
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import HomeIcon from '@material-ui/icons/Home';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import HelpIcon from '@material-ui/icons/Help';
import { useHistory } from 'react-router';
import useSimplyTeam from '../../../pch/hooks/useSimplyTeam';
import { PeopleAlt } from '@material-ui/icons';
import useActiveMenu from '../../../pch/hooks/useActiveMenu';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

function MobileFooter() {
	// eslint-disable-next-line no-unused-vars
	const [value, setValue] = React.useState(0);
	const history = useHistory();
	const { sb } = useSimplyTeam();
	const { active } = useActiveMenu();
	return (
		<div className='z-50 w-full p-3 fixed bottom-0 bg-gradient-to-r from-sbBrightGreen to-sbBrightBlue'>
			<BottomNavigation
				value={active}
				onChange={(event, newValue) => {
					setValue(newValue);
				}}
				className='rounded-full'
			>
				<BottomNavigationAction
					value='dashboard'
					label='Home'
					icon={<HomeIcon />}
					onClick={() => history.push('/')}
				/>
				<BottomNavigationAction
					value='payments'
					label='Payments'
					icon={<AccountBalanceIcon />}
					onClick={() => history.push('/payments')}
				/>
				<BottomNavigationAction
					value='profile'
					label='Profile'
					icon={<AccountBoxIcon />}
					onClick={() => history.push('/profile')}
				/>

				{sb ? (
					<BottomNavigationAction
						value='people'
						label='Users'
						icon={<PeopleAlt />}
						onClick={() => history.push('/people')}
					/>
				) : (
					<BottomNavigationAction
						value='help'
						label='Help'
						icon={<HelpIcon />}
						onClick={() => history.push('/help')}
					/>
				)}
				<BottomNavigationAction
					value='logout'
					label='Logout'
					icon={<ExitToAppIcon />}
					onClick={() => history.push('/logout')}
				/>
			</BottomNavigation>
		</div>
	);
}

export default MobileFooter;
